/**
 * Shared channel state utilities for SDK-based offline/degraded detection.
 */
import phenix from '@phenixrts/sdk';

export const FAILED_STATES = [
  phenix.ChannelState.StandBy,
  phenix.ChannelState.Offline,
  phenix.ChannelState.Error,
  phenix.ChannelState.Stopped,
  phenix.ChannelState.Unauthorized,
  phenix.ChannelState.ConfigurationError,
  phenix.ChannelState.ConnectionError,
  phenix.ChannelState.ClientStartError
];

export function isChannelOffline(state) {
  return state != null && FAILED_STATES.includes(state);
}
